import PropTypes from 'prop-types';
import { FaFile } from 'react-icons/fa';

export const BotonVerAtencionesPersona = ({ verAtencionesPersona, id, row, text }) => {
  return (
    <div>
        <button  
          id={id} 
          type="button" 
          onClick={() => verAtencionesPersona(row)} 
          style={{
              backgroundColor: 'skyblue',
              padding: '12px 20px',
              fontSize: '1.5rem',
              borderRadius: '8px',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
          }}
          data-tooltip-id='tooltiparriba'
          data-tooltip-content={text || "Ver atenciones de la persona"}
          >
                <FaFile/>
        </button>
    </div>
       
  );
};

BotonVerAtencionesPersona.propTypes = {
  verAtencionesPersona: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  row: PropTypes.shape({}).isRequired,
  text: PropTypes.string,
};
